import { animate, AnimationTriggerMetadata, query, style, transition, trigger, group } from '@angular/animations';

export const pieceProductCarouselAnimations: AnimationTriggerMetadata = trigger('slider', [
    transition(':increment', group([
        query(':enter', [
            style({
                opacity: 0,
                transform: 'translateX(100%)',
            }),
            animate('0.6s cubic-bezier(0.12, 0.54, 0.26, 1.07)', style('*')),
        ]),
    ])),
    transition(':decrement', group([
        query(':enter', [
            style({
                opacity: 0,
                transform: 'translateX(-100%)',
            }),
            animate('0.6s cubic-bezier(0.12, 0.54, 0.26, 1.07)', style('*')),
        ]),
    ])),
]);
